import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const Stats101Page = () => {
  useEffect(() => {
    document.title = 'Stats 101 | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
    
    // Initialize Bootstrap collapse functionality after scripts are loaded
    const initializeBootstrap = () => {
      setTimeout(() => {
        if (window.$ && window.$.fn.collapse) {
          // Initialize Bootstrap collapse
          window.$('.panel-collapse').collapse('hide');
          window.$('#collapseOne').collapse('show'); // Show first panel by default
          
          // Add click handlers for accordion
          window.$('[data-toggle="collapse"]').off('click').on('click', function(e) {
            e.preventDefault();
            const target = window.$(this).attr('href');
            const parent = window.$(this).attr('data-parent');
            
            if (parent) {
              window.$(parent + ' .panel-collapse').collapse('hide');
            }
            window.$(target).collapse('toggle');
          });
          
          console.log('✅ Bootstrap accordion initialized');
        } else {
          // Retry if Bootstrap not loaded yet
          setTimeout(initializeBootstrap, 500);
        }
      }, 2000); // Wait for PublicHeader to load scripts
    };
    
    initializeBootstrap();
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/rules">
          <div id="stick_right"></div>
        </Link>

        {/* Stats Container */}
        <div id="basic">
          <h3 className="heading3">Stats 101</h3>
          <p className="basic_p">Learn how to calculate common baseball statistics with these easy-to-follow formulas and examples.</p>
          
          <div className="panel-group" id="accordion">
                    
                    {/* Batting Average */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
                            <i className="fa fa-calculator" style={{fontSize: '24px', color: '#464646'}}></i>
                            {' '}Batting Average (AVG)
                          </a>
                        </h4>
                      </div>
                      <div id="collapseOne" className="panel-collapse collapse in">
                        <div className="panel-body">
                          Divide the number of base hits by the total number of at bats. If Tony Gwynn has 600 at bats and has 206 hits<br />
                          His batting average would be .343 (206/600)
                        </div>
                      </div>
                    </div>

                    {/* Earned Run Average */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
                            <i className="fa fa-calculator" style={{fontSize: '24px', color: '#464646'}}></i>
                            {' '}Earned Run Average (ERA)
                          </a>
                        </h4>
                      </div>
                      <div id="collapseTwo" className="panel-collapse collapse">
                        <div className="panel-body">
                          Multiply the total number of earned runs by nine, and divide the results by the total innings pitched.Randy Johnson has allowed 67 runs in 220 innings. What's his ERA?<br />
                          Multiply 67 by 9: 67x9=603. Divide 603 by 220 (his innings pitched): 603/220=2.74. That's his ERA.
                        </div>
                      </div>
                    </div>

                    {/* W-L percentage */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseThree">
                            <i className="fa fa-calculator" style={{fontSize: '24px', color: '#464646'}}></i>
                            {' '}W-L percentage
                          </a>
                        </h4>
                      </div>
                      <div id="collapseThree" className="panel-collapse collapse">
                        <div className="panel-body">
                          Divide the number of games won by the total number of decisions. Pedro Martinez has a 16-3 record.<br />
                          Divide his win total(16) by his total number of decisions (19):16/19=0.842
                        </div>
                      </div>
                    </div>

                    {/* Slugging Percentage */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseFour">
                            <i className="fa fa-calculator" style={{fontSize: '24px', color: '#464646'}}></i>
                            {' '}Slugging Percentage (SLG)
                          </a>
                        </h4>
                      </div>
                      <div id="collapseFour" className="panel-collapse collapse">
                        <div className="panel-body">
                          Divide the total number of bases of all base hits by the total number of times at bat Sammy Sosa has 282 total bases and 440 at-bats.<br />
                          Divide 282 by 440 to get his slugging percentage: 282/440=.641
                        </div>
                      </div>
                    </div>

                    {/* On-Base Percentage */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseFive">
                            <i className="fa fa-calculator" style={{fontSize: '24px', color: '#464646'}}></i>
                            {' '}On-Base Percentage (OBP)
                          </a>
                        </h4>
                      </div>
                      <div id="collapseFive" className="panel-collapse collapse">
                        <div className="panel-body">
                          Divide the total number of hits plus Bases on Balls plus hits by Pitch BY at Bats plus Bases on Balls plus hit by Pitch plus Sacrifice Flies In Derek Jeter's 434 at-bats, he has 152 hits, 59 walks, and has been hit by 9 pitches. He's hit 6 sacrifice flies.
                          So here's the formula to determine his on-base average: (152+59+9)/(434+59+9+6)=220/508=.433
                        </div>
                      </div>
                    </div>

                    {/* Fielding Average */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseSix">
                            <i className="fa fa-calculator" style={{fontSize: '24px', color: '#464646'}}></i>
                            {' '}Fielding Average
                          </a>
                        </h4>
                      </div>
                      <div id="collapseSix" className="panel-collapse collapse">
                        <div className="panel-body">
                          Divide the total number of putouts and assists by the total number of putouts, assists and errors. Edgardo Alfonzo has 218 putouts and 290 assists, while committing only 2 errors.<br />
                          So his fielding percentage is : (218+290)/(218+290+2)=508/510=.996
                        </div>
                      </div>
                    </div>

                    {/* Magic Numbers */}
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseSev">
                            <i className="fa fa-calculator" style={{fontSize: '24px', color: '#464646'}}></i>
                            {' '}Magic Numbers
                          </a>
                        </h4>
                      </div>
                      <div id="collapseSev" className="panel-collapse collapse">
                        <div className="panel-body">
                          Determine the number of games yet to be played, add one, then subtract the number of games ahead in the loss column of the standings from the closest opponent. So here's Texas' magic number.<br />
                          remaining (50) +1=51. 51-7=44. The Rangers' magic number to clinch the AL West is 44.
                        </div>
                      </div>
                    </div>

          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default Stats101Page;